module.exports = __webpack_public_path__ + "img/stand_linche_alert_cut.975e1288.png";